
const mainReducer = (state,action) =>{

    switch (action.type) {
        // case value:
            
        //     break;
    
        default:
            return state;
    }
}

export default mainReducer